import { Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'hr-wyswyg',
  templateUrl: './hr-wyswyg.component.html',
  styleUrls: ['./hr-wyswyg.component.css']
})
export class HrWyswygComponent extends ElementComponent {
  @Input() override data: any = {

  }
}
